module.exports = __webpack_public_path__ + "static/img/3s-platform-img8.2744766.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/3s-platform-img8.png
// module id = UdWZ
// module chunks = 0